const mapInfo = {
  "jxc-portal-crm": {
    name: "jxc-portal-crm",
    title: "地勤",
    slogan: "",
    baseUrl: "/crm",
    base: "/bd",
    hash: "/#",
    BI: {
      cardName: "地勤人员总览",
      cardComp: require("@/components/views-card/bd_card"),
      firstBIName: "战区BD详情",
      secBIName: "BD详情总览",
    },
    headerLeft: [],
  },
  "jxc-portal-cms": {
    name: "jxc-portal-cms",
    title: "运营端",
    slogan: "保泰持盈",
    baseUrl: "/cms",
    base: "",
    hash: "",
    BI: {
      cardName: "运营指标数据",
      cardComp: require("@/components/views-card"),
      firstBIName: "访问次数",
      secBIName: "访问人数",
    },
    headerLeft: [
      require("@/layout/components/area-apply-btn/index.tsx").default,
      require("@/layout/components/organize-apply-btn/index.tsx").default,
    ],
  },
};

// const getEnvInfo = () => mapInfo[localStorage.getItem("evnPreFix") || 'jxc-portal-crm']
const getEnvInfo = () => mapInfo["jxc-portal-crm"];

module.exports = getEnvInfo();
